import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
import * as S from './index.styles';

interface LoaderProps {
  size?: number;
  color?: string;
  message?: string;
  className?: string;
}

const Loader: React.FC<LoaderProps> = ({
  size = 40,
  color = '#fe2f67',
  message,
  className
}) => {
  return (
    <S.LoaderContainer className={className}>
      <CircularProgress size={size} style={{ color }} />
      {message && <S.LoaderMessage>{message}</S.LoaderMessage>}
    </S.LoaderContainer>
  );
};

export default Loader; 